import React, { createContext, useContext, useState } from 'react';

// Tworzymy kontekst
const UserContext = createContext();

// Provider kontekstu
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null); // Globalny stan dla użytkownika

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

// Hook do używania kontekstu
export const useUser = () => {
    return useContext(UserContext);
};
